// extracted by mini-css-extract-plugin
export var compactFilters = "_cd-4";
export var detailImage = "_cd-1";
export var dropdownContainer = "_cd-2";
export var imageContainer = "_cd-0";
export var selectedCard = "_cd-3";